
export default {

    install(Vue) {
        

        Vue.prototype.$global = {
        };

        Vue.prototype.$grid = (colTemplate, gap = "10px") => {
            let templateValues = colTemplate.toString().split('-');
            let columnTemplate = ""
            templateValues.forEach(value => {
                columnTemplate += ' '
                if (value.includes('px') ||
                    value.includes('%') ||
                    value.includes('cm') ||
                    value.includes('mm') ||
                    value.includes('in') ||
                    value.includes('pt') ||
                    value.includes('pc') ||
                    value.includes('em') ||
                    value.includes('ex') ||
                    value.includes('ch') ||
                    value.includes('rem') ||
                    value.includes('vw') ||
                    value.includes('vh') ||
                    value.includes('vmin') ||
                    value.includes('vmax')) {

                    columnTemplate += value
                } else {
                    columnTemplate += value + 'fr'
                }
            })
            let gapOutside = gap.split(' ');
            gapOutside = parseInt(gapOutside[0])

            return {
                width: '100%',
                display: 'grid',
                gridTemplateColumns: columnTemplate,
                gridGap: gap,
                marginBottom: gapOutside + 'px',
            }
        };

    }

}